import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/shared/services/environment.service';
import { NotificationService } from '../../shared/services/notification.service';
import {
  EnvironmentsLoad,
  EnvironmentsLoadError,
  EnvironmentsLoadSuccess,
  ENVIRONMENTS_LOAD,
  ENVIRONMENTS_LOAD_ERROR,
  ENVIRONMENTS_LOAD_SUCCESS,
} from '../actions/environments.actions';
import { AppState } from '../reducers';

@Injectable()
export class EnvironmentEffects {
  public environmentsLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType<EnvironmentsLoad>(ENVIRONMENTS_LOAD),
      tap(() => (this.notificationService.loading = true)),
      withLatestFrom(this.store.select(state => state.environments)),
      mergeMap(([action, storeEnvironments]) => {
        if (storeEnvironments === null) {
          return this.environmentService.getAllEnvironments().pipe(
            map(environments => new EnvironmentsLoadSuccess(environments)),
            catchError(() => of(new EnvironmentsLoadError()))
          );
        } else {
          return EMPTY;
        }
      })
    )
  );

  public environmentsLoadSucces$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EnvironmentsLoadSuccess>(ENVIRONMENTS_LOAD_SUCCESS),
        tap(() => (this.notificationService.loading = false))
      ),
    { dispatch: false }
  );

  public environmentsLoadError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EnvironmentsLoadError>(ENVIRONMENTS_LOAD_ERROR),
        tap(() => (this.notificationService.loading = false)),
        tap(() => this.notificationService.openSnackBar('error', 'COMMON.ENVIRONMENTS_NOT_LOADED'))
      ),
    { dispatch: false }
  );

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService,
    private environmentService: EnvironmentService
  ) {}
}
